import { SceneSetters } from "../../types";

const sceneConfig: Phaser.Types.Scenes.SettingsConfig = {
  active: false,
  visible: false,
  key: "End",
};

export default class EndScene extends Phaser.Scene {
  private cursorKeys?: Phaser.Input.Keyboard.Key;

  private setter: SceneSetters;

  constructor(setter: SceneSetters) {
    super(sceneConfig);
    this.cursorKeys = undefined;
    this.setter = setter;
  }

  public create() {
    this.cursorKeys = this.input.keyboard.addKey("Space");
  }

  public update() {
    // handle up/down cursor keys
    if (this.cursorKeys?.isDown) document.location.reload();
  }
}
